import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs from "dayjs"
import { AxisTypeEnum } from "../../common/enum/axisType.enum"
import { ChartEnum } from "../../common/enum/chart.enum"
import { ChartTypeEnum } from "../../common/enum/chartType.enum"
import { FilterChartGUIInterface } from "../../common/interfaces/filterChartGUI.interface"
import { FilterChartSearchConditionInterface } from "../../common/interfaces/filterChartSearchCondition.interface"
import { getMaxDateChart } from "../../common/helper/date.helper"
import { defaultApp, defaultProvince } from "../../common/variables/filterChart"

export interface ChartChargeWalletState {
   requesting: boolean
   excelExporting: boolean
   error: string
   successful: boolean
   filter: FilterChartGUIInterface
   searchCondition: FilterChartSearchConditionInterface
   data: any[]
}

const initialState: ChartChargeWalletState = {
   requesting: false,
   excelExporting: false,
   error: "",
   successful: false,
   filter: {
      chartType: ChartTypeEnum.SIN,
      axisType: AxisTypeEnum.VERTICAL,
   },
   searchCondition: {
      type: ChartEnum.NONE,
      fromDate: dayjs(getMaxDateChart()),
      toDate: dayjs(getMaxDateChart()),
      app: [defaultApp],
      province: [defaultProvince],
   },
   data: [],
}

export const chartChargeWalletSlice = createSlice({
   name: "chartChargeWallet",
   initialState,
   reducers: {
      requestChartChargeWallet: (state: ChartChargeWalletState) => {
         state.requesting = true
      },
      getChartChargeWalletSuccess: (
         state: ChartChargeWalletState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = true
         state.error = ""
         state.data = action.payload
      },
      getChartChargeWalletFail: (
         state: ChartChargeWalletState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = false
         state.error = action.payload
         state.data = []
      },
      changeFilter: (
         state: ChartChargeWalletState,
         action: PayloadAction<any>
      ) => {
         state.filter = { ...state.filter, ...action.payload }
      },
      changeSearchCondtion: (
         state: ChartChargeWalletState,
         action: PayloadAction<any>
      ) => {
         if (
            action.payload.type === ChartEnum.APP ||
            action.payload.type === ChartEnum.PROVINCE
         ) {
            state.filter.chartType = ChartTypeEnum.BAR
            state.filter.axisType = AxisTypeEnum.VERTICAL
         }

         if (
            action.payload.type === ChartEnum.DAY ||
            action.payload.type === ChartEnum.MONTH ||
            action.payload.type === ChartEnum.YEAR
         ) {
            state.filter.chartType = ChartTypeEnum.SIN
         }

         if (action.payload.type) {
            state.searchCondition.fromDate = dayjs(getMaxDateChart())
            state.searchCondition.toDate = dayjs(getMaxDateChart())
         }

         state.data = []
         state.searchCondition = { ...state.searchCondition, ...action.payload }
      },
      startExportExcelChartChargeWallet: (state: ChartChargeWalletState) => {
         state.excelExporting = true
      },
      finishExportExcelChartChargeWallet: (state: ChartChargeWalletState) => {
         state.excelExporting = false
      },
   },
})

export const {
   requestChartChargeWallet,
   getChartChargeWalletSuccess,
   getChartChargeWalletFail,
   changeFilter,
   changeSearchCondtion,
   startExportExcelChartChargeWallet,
   finishExportExcelChartChargeWallet,
} = chartChargeWalletSlice.actions

export default chartChargeWalletSlice.reducer
